import { createContext } from 'react';

/** The three selectable theme modes. */
export type ThemeMode = 'light' | 'dark' | 'system';

export interface ThemeContextValue {
  /** User-stored preference; may be 'system'. */
  mode: ThemeMode;
  /** Resolved theme rendered on screen. */
  effectiveTheme: 'light' | 'dark';
  /** Update and persist the theme preference. */
  setTheme: (mode: ThemeMode) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
